export const serverUrl = process.env.REACT_APP_SERVER_URL

// Resident PWA (Safelto Resident). Staging builds set REACT_APP_RESIDENT_PWA_URL=https://resident-dev.safelto.com
export const residentPwaUrl = (process.env.REACT_APP_RESIDENT_PWA_URL || 'https://resident.safelto.com').replace(/\/+$/, '')
export const residentPwaLink = (path = '/') => `${residentPwaUrl}${path}`
